<template>
  <el-row class="info">
    <el-col :span="14">
      <div class="i-sector">
        <p class="title"><i class="fas fa-map-marker-alt"/>Top localidades</p>
      </div>
      <div :span="20" class="top-sector">
        <p>1. <span v-if="sector.topLocalities[0]">{{sector.topLocalities[0][0]}}</span></p>
        <p>2. <span v-if="sector.topLocalities[1]">{{sector.topLocalities[1][0]}}</span></p>
        <p>3. <span v-if="sector.topLocalities[2]">{{sector.topLocalities[2][0]}}</span></p>
      </div>
    </el-col>
    <el-col :span="10" class="i-sector">
      <Detail icon="fas fa-truck-loading" :text="totalVolume + ' m'" info="volumetría" sup="3"/>
      <Detail icon="fas fa-truck" :text="sector.vehicles.length | pluralized('vehículo')"/>
      <Detail icon="fas fa-box" :text="sector.suborders.length | pluralized('soc')"/>
      <Detail icon="fas fa-dollar-sign" :text="totalPrice + '%'" info="valor/seguro de carga"/>
    </el-col>
  </el-row>
</template>

<script>
import Detail from './Detail.vue';

export default {
  name: 'Info',
  props: {
    sector: {
      type: Object,
      default() {
        return {};
      },
    },
    index: Number,
  },
  components: {
    Detail,
  },
  data() {
    return {
      modeName: '',
    };
  },
  mounted() {
  },
  filters: {
    pluralized(quantity, word) {
      const finalWord = `${quantity} ${word}`;
      return quantity === 1 ? finalWord : `${finalWord}s`;
    },
  },
  watch: {
    newData() {
    },
    newDataFull: {
      handler() {
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    newMethod() {
    },
  },
  computed: {
    totalVolume() {
      return `${this.sector.currentVolume.toFixed(2)}
      /${this.sector.maximumVolume.toFixed(2)}`;
    },
    totalPrice() {
      return this.sector.maximumPrice !== 0
        ? ((this.sector.currentPrice / this.sector.maximumPrice) * 100)
          .toFixed(2) : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .info {
    margin-left: 10px;
  }
  p {
    font-size: 12px;
    margin: 0 0 2px 0;
  }
  .i-sector {
    p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    i { color: #d2d2d2; }
    .title { padding-bottom: 4px; }
    .fa-box { margin-right: 9px; }
    .fa-truck { margin-right: 6px; }
    .fa-dollar-sign { margin: 0 9px 0 3px; }
    .fa-map-marker-alt { margin-right: 4px; }
    .fa-truck-loading { margin-right: 4px; }
  }
  .top-sector {
    p {
      margin: 0 6px 2px 6px;
      font-weight: 700;
      font-size: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
